import { useMemo } from 'react'

export type StringOptionProps = {
  value: null | string
  onChange: (value: string) => any
  options: string[]
}
export type ValueOptionProps = {
  value: null | any
  onChange: (value: any) => any
  options: {
    value: any
    label: string
    isParentSection?: boolean
    indent?: number
  }[]
}

export type OptionProps = StringOptionProps | ValueOptionProps

export const useInputOptions = ({ options, value }: OptionProps) => {
  const parsedOptions = useMemo(() => {
    return options.map(
      (
        option:
          | string
          | {
              value: any
              label: string
              isParentSection?: boolean
              indent?: number
            },
      ) =>
        typeof option === 'string' ? { value: option, label: option } : option,
    )
  }, [options])
  const selectedOption = useMemo(() => {
    if (value) {
      return parsedOptions.find(option => option.value === value)
    }
    return null
  }, [value, parsedOptions])

  return {
    selected: selectedOption,
    options: parsedOptions,
  }
}
